import React from 'react';
import styled from 'styled-components';

interface propType  {
    children: JSX.Element
    backgroundColor?: string;
    fontColor?: string;
    lowercase?: boolean;
}

const ModalHeader = (props: propType) => {
    const { fontColor, backgroundColor, lowercase } = props
    return (
        <Header lowercase={lowercase} fontColor={fontColor} backgroundColor={backgroundColor}>
            {props.children}
        </Header>
    )
}

const Header = styled.div`
    width: 100%;
    box-sizing: border-box;
    border-radius: 5px 5px 0 0;
    background-color: ${props => props.backgroundColor ? props.backgroundColor : '#335D7C'};
    font-family: 'Montserrat';
    font-weight: 600;
    padding: 10px 0;
    font-size: 1.3em;
    h1, h2, h3, h4, h5, h6{
        padding: 0;
        margin: 0 0 0 30px;
        color: ${props => props.fontColor ? props.fontColor : '#FFFFFF'};
        ${props => props.lowercase ? '' : 'text-transform: uppercase'};
    }
`

export default ModalHeader
